// extracted by mini-css-extract-plugin
export var announcement = "services-module--announcement--6508f";
export var background = "services-module--background--fc595";
export var button = "services-module--button--ef037";
export var buttonContainer = "services-module--buttonContainer--b7c55";
export var button_wide = "services-module--button_wide--4f505";
export var form = "services-module--form--220bf";
export var iframeContainer = "services-module--iframe-container--d3f8d";
export var message = "services-module--message--07b8a";
export var pageHeading = "services-module--pageHeading--9cd8f";
export var text = "services-module--text--208f0";